import baseApi from "@/api/baseApi";
import { b64toBlob, saveBlob } from "@/helpers/saveFile";

const api = {
  async getDocuments(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/documents/${projectId}`,
      data: { hideLoader: true },
    });

    return response.data;
  },
  async getFolderDocuments(projectId, folderUuid) {
    const response = await baseApi({
      method: "get",
      url: `/documents/${projectId}/${folderUuid}`,
      data: { hideLoader: true },
    });

    return response.data;
  },
  async getDocumentsUuid(projectId, folderUuid) {
    const response = await baseApi({
      method: "get",
      url: `/documents/uuid/${projectId}/${folderUuid}`,
      data: { hideLoader: true },
    });
    return response.data;
  },
  async updateDocument(fileUuid, file) {
    const response = await baseApi.put(
      `/documents/${fileUuid}/newversion`,
      file
    );
    return response.data;
  },
  async uploadDocument(projectId, folderUuid, file) {
    const response = await baseApi.post(
      `/documents/${projectId}/${folderUuid}`,
      file
    );
    return response.data;
  },
  async downloadDocument(document) {
    const response = await baseApi.post(`/documents/download`, document);

    const blob = b64toBlob(response.data.file, response.data.contentType);
    saveBlob(blob, response.data.fileName);
  },
  async convertToPdfDocument(document) {
    const response = await baseApi.post(`/documents/converttopdf`, document);

    const blob = b64toBlob(response.data.file, response.data.contentType);

    saveBlob(blob, response.data.fileName);
  },

  async getHmsDocuments(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/documents/hms/${projectId}`,
      data: { hideLoader: true },
    });
    return response.data;
  },
  async getAccidentDocuments(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/documents/accident/${projectId}`,
      responseType: "blob",
    });

    return response.data;
  },
  async getBlueprintsDocuments(projectId) {
    const response = await baseApi({
      method: "get",
      url: `/documents/blueprints/${projectId}`,
      data: { hideLoader: true },
    });

    return response.data;
  },
  async getBlueprintsHouseDocuments(projectId, houseId) {
    const response = await baseApi({
      method: "get",
      url: `/documents/blueprints/${projectId}/${houseId}`,
      data: { hideLoader: true },
    });

    return response.data;
  },
  async downloadMergedPdfs(documents, fileName) {
    const response = await baseApi.post(`/documents/mergepdfs?fileName=${fileName}`, documents);
    const blob = b64toBlob(response.data.file, response.data.contentType);
    saveBlob(blob, response.data.fileName);
  }
};

export default api;
